import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valeurNumeriqueFr'
})
export class ValeurNumeriqueFrPipe implements PipeTransform {

  transform(value: number): unknown {
    const formatter = new Intl.NumberFormat('fr-FR', {
      style: 'decimal'
    });
    return formatter.format(value)
  }

}
